import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Eye, EyeOff } from "lucide-react";
import { TextField } from "./TextField";

interface PasswordFieldProps {
  label: string;
  placeholder?: string;
  autoComplete?: string;
  disabled?: boolean;
  readOnly?: boolean;
  id?: string;
}

export function PasswordField({
  label,
  placeholder,
  autoComplete,
  disabled,
  readOnly,
  id,
}: PasswordFieldProps) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  return (
    <TextField
      label={label}
      type={visible ? "text" : "password"}
      placeholder={placeholder}
      autoComplete={autoComplete}
      disabled={disabled}
      readOnly={readOnly}
      id={id}
      suffix={
        <button
          type="button"
          tabIndex={-1}
          onClick={() => setVisible((v) => !v)}
          className="absolute top-1/2 right-3 -translate-y-1/2 text-muted hover:text-subtle transition-colors"
          aria-label={visible ? t("common.hidePassword") : t("common.showPassword")}
        >
          {visible ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
      }
    />
  );
}
